import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

export default class AnalyticsConfig extends DefaultAnalyticsConfig {
  //overwrite configs if needed
  static gaTag = "UA-74657641-4";

  static cmp = {
    hasPreferenceView: true,
    key: "7b02b7c5-542b-4e58-be72-3b656a0c4bbe",

    features: {
      GA: true,
      socialSharing: false,
    },

    GA: {
      vendorId: "c:googleana-iHYTahgE",
      purposeId: ["daLcqNkH"],
    },
  };
}



// WEBPACK FOOTER //
// ./clients/cfr-mt/js/analyticsConfig.js